/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const pricingSlice = createSlice({
  name: 'pricing',
  initialState: {
    pricingData: [],
    selectedPricing: null, 
  },
  reducers: {
    setPricingData: (state, action) => {
      state.pricingData = action.payload;
    },
    setSelectedPricing: (state, action) => {
      state.selectedPricing = action.payload; 
    },
    updatePricing: (state, action) => {
      const updatedItem = action.payload;
      const index = state.pricingData.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        state.pricingData[index] = updatedItem;
      }
    }
  },
});

export const { setPricingData, setSelectedPricing,updatePricing } = pricingSlice.actions;

export default pricingSlice.reducer;
